/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendlyEventTypes } from '../../models/calendly-event-types';

export interface ListCalendlyEventTypes$Params {
}

export function listCalendlyEventTypes(http: HttpClient, rootUrl: string, params?: ListCalendlyEventTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendlyEventTypes>> {
  const rb = new RequestBuilder(rootUrl, listCalendlyEventTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendlyEventTypes>;
    })
  );
}

listCalendlyEventTypes.PATH = '/v1/api/ui/calendly-demo/event-types';
